import service from '../service/card'
import CONSTANT from '../constant/card'
import STATUS_CODE from '../constant/status_code'

import _ from 'underscore'
import { Indicator } from 'mint-ui';
import { historyStorageFun } from '../util/function'
import Progress from '../lib/progress'
import { promises } from 'stream';

const historyStorage = historyStorageFun(CONSTANT.CARD_CINEMAHISTORY_KEY)

export default {
    getCardDetail({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getCardDetail(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDDETAIL_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                if (e.status == STATUS_CODE.CARD_CHANNEL_ERROR) {//
                    Indicator.close();
                    return
                }
                // commit('rootApperError', e.msg)
                Indicator.close();
            })
        })
    },
    // 根据唯一码查询卡详情
    getCardDetailOnly({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getCardDetailOnly(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDDETAIL_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                if (e.status == STATUS_CODE.CARD_CHANNEL_ERROR) {//
                    Indicator.close();
                    return
                }
                // commit('rootApperError', e.msg)
                Indicator.close();
            })
        })
    },
    cardBinding({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.cardBinding(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_CARDBINDING_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_CARDBINDING_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    getCardToken({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.getCardToken(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDTOKEN_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETCARDTOKEN_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    cardRenew({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.cardRenew(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_CARDRENEW_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_CARDRENEW_ERROR, e)
                Indicator.close();
            })
        })
    },
    cardRenewV2 ({commit}, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.cardRenewV2(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_CARDRENEW_V2_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_CARDRENEW_V2_ERROR, e)
                Indicator.close();
            })
        })
    },
    removeCardBinding({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.removeCardBinding(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_REMOVECARDBINDING_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_REMOVECARDBINDING_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    getCardPassword({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.getCardPassword(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDPASSWORD_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETCARDPASSWORD_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    getUsefulCards({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.getUsefulCards(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETUSEFULCARDS_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETUSEFULCARDS_ERROR, e)
                // commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    getUselessCards({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getUselessCards(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETUSELESSCARDS_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETUSELESSCARDS_ERROR, e)
                // commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    getLimitCity({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getLimitCity(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETLIMITCITY_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETLIMITCITY_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    resetLimitCinema({ commit }) {
        commit(CONSTANT.CARD_RESETLIMITCINEMA)
    },
    getLimitCinema({ commit }, data) {
        Indicator.open()
        return new Promise((resolve, reject) => {
            return service.getLimitCinema(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETLIMITCINEMA_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETLIMITCINEMA_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    //获取影院详情
    getCinemaInfo({ commit, state }, id) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            const preDetail = state.cinemaInfo[id]
            if (preDetail) {
                commit(CONSTANT.CINEMA_GET_INFO_SUCCESS, { id, cinema: preDetail })
                setTimeout(() => {
                    Indicator.close();
                }, 0)
                return resolve(preDetail)
            }
            return service.getCinemaInfo(id).then(res => {
                commit(CONSTANT.CINEMA_GET_INFO_SUCCESS, { id, cinema: res.cinema })
                return resolve(res.cinema)
            }, e => {
                commit(CONSTANT.CINEMA_GET_INFO_ERROR, e)
                return reject(e)
            }).finally(() => {
                Indicator.close()
            })
        })
    },
    getCinemaSearchHistory({ commit }) {
        return new Promise((resolve, reject) => {
            const historyList = historyStorage.get()
            commit(CONSTANT.CARD_GET_CINEMAHISTORY_SUCCESS, historyList)
            resolve(historyList)
        })
    },
    setCinemaSearchHistory({ commit }, data) {
        return new Promise((resolve, reject) => {
            let historyList = historyStorage.get()
            historyList = historyList.filter(item => item !== data)
            if (historyList.length > CONSTANT.CARD_MAX_CINEMAHISTORY) {
                historyList.pop()
            }
            historyList.unshift(data)
            historyStorage.set(historyList)
            commit(CONSTANT.CARD_SET_CINEMAHISTORY_SUCCESS, historyList)
            resolve(historyList)
        })
    },
    clearCinemaSearchHistory({ commit }) {
        return new Promise((resolve, reject) => {
            const result = historyStorage.clear()
            commit(CONSTANT.CARD_CLEAR_CINEMAHISTORY_SUCCESS)
            resolve(result)
        })
    },
    removeCinemaSearchHistory({ commit }, data) {
        return new Promise((resolve, reject) => {
            let historyList = historyStorage.get()
            historyList = historyList.filter(item => item !== data)
            historyStorage.set(historyList)
            commit(CONSTANT.CARD_REMOVE_CINEMAHISTORY_SUCCESS, historyList)
            resolve(historyList)
        })
    },
    getCardBanner({ commit }, data) {
        return new Promise((resolve, reject) => {
            return service.getCardBanner(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDBANNER_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETCARDBANNER_ERROR, e)
                commit('rootApperError', e)
            })
        })
    },
    getCardConsume({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getCardConsume(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDCONSUME_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETCARDCONSUME_ERROR, e)
                Indicator.close();
            })
        })
    },
    getCardBillList({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getCardBillList(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETCARDBILLLIST_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_GETCARDBILLLIST_ERROR, e)
                Indicator.close();
            })
        })
    },
    cardChangePassNotify ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.cardChangePassNotify(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_CARDCHANGEPASSNOTIFY_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.CARD_CARDCHANGEPASSNOTIFY_ERROR, e)
            })
        })
    },
    // 进店使用-选择品牌获取品牌列表    
    getPinPaiList ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getPinPaiList(data).then(result => {
                resolve(result)
                commit(CONSTANT.CARD_GETPINPAILIST_SUCCESS, result)
                return result
            }, e => {                
                reject(e)
                commit(CONSTANT.CARD_GETPINPAILIST_ERROR, e)
            })
        })
    },
    // 进店使用-获取账单消费详情    
    getBillListShop ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getBillListShop(data).then(result => {
                resolve(result)
                //设置账单详情数据
                commit("setBillData",result.billList[0])
                return result
            }, e => {                
                reject(e)                
            })
        })
    },
    // 进店使用-获取二维码
    getPaymentCode ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getPaymentCode(data).then(result => {
                resolve(result)
                commit("setPaymentCode", result)
                return result
            }, e => {                
                reject(e);                
            })
        })
    },
    // 进店使用-获取最近门店
    getRecentShop ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getRecentShop(data).then(result => {
                resolve(result)
                commit("setRecentShop", result)
                return result
            }, e => {                
                reject(e);                
            })
        })
    },
    // 进店使用-获取消费记录数据
    getrecordsPay ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getrecordsPay(data).then(result => {
                resolve(result)
                //设置消费记录数据
                commit("setRecordsPay", result)
                return result
            }, e => {                
                reject(e);                
            })
        })
    },
    /*yeoman-template-point-1*/
}
